import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-blue-600 text-white py-8 px-4" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <div className="text-center mb-6" data-id="element-116">
          <p className="font-bold text-lg mb-1" data-id="element-117">
            Nevara Québec - Votre partenaire santé depuis 2024
          </p>
          <p className="text-sm" data-id="element-118">
            Entreprise québécoise • Service en français • Satisfaction garantie
          </p>
        </div>
        <div className="bg-blue-700 p-4 rounded-lg mb-6" data-id="element-119">
          <h3 className="font-bold mb-2" data-id="element-120">Avertissement Médical :</h3>
          <p className="text-sm" data-id="element-121">
            Ce produit n'est pas destiné à diagnostiquer, traiter, guérir ou
            prévenir une maladie. Les résultats peuvent varier d'une personne à
            l'autre. Consultez toujours votre médecin avant de commencer tout
            nouveau traitement. Les témoignages présentés sont basés sur des
            expériences individuelles et ne garantissent pas des résultats
            similaires.
          </p>
        </div>
        <div className="bg-blue-700 p-4 rounded-lg mb-6" data-id="element-122">
          <h3 className="font-bold mb-2" data-id="element-123">
            À Propos de Dr. François Martineau :
          </h3>
          <p className="text-sm" data-id="element-124">
            Les informations présentées dans cet article sont basées sur des
            recherches médicales publiées et des pratiques cliniques établies.
            Dr. Martineau est un personnage composite représentant l'expertise
            collective de plusieurs spécialistes en diabétologie.
          </p>
        </div>
        <div className="text-center text-sm" data-id="element-125">
          <p className="mb-2" data-id="element-126">
            Nevara Québec | support@nevara-quebec.com | 1-800-NEVARA-1
          </p>
          <p data-id="element-127">
            Montréal, Québec, Canada | Conditions d'utilisation | Politique de
            confidentialité
          </p>
        </div>
      </div>
    </footer>;
};